import { exists } from '@/api'

export interface BatchUserListCondition {
  userRegistrationDateFrom: string
  userRegistrationDateTo: string
  userRegistrationBranchCode: string
  userType: string
  order: string
}

export function BatchUserListConditionFromJSON(
  json: any
): BatchUserListCondition {
  const _json = JSON.parse(json)

  return {
    userRegistrationDateFrom: exists(_json, 'user_registration_date_from')
      ? _json.user_registration_date_from
      : '',
    userRegistrationDateTo: exists(_json, 'user_registration_date_to')
      ? _json.user_registration_date_to
      : '',
    userRegistrationBranchCode: exists(_json, 'user_registration_branch_code')
      ? _json.user_registration_branch_code
      : '',
    userType: exists(_json, 'user_type') ? _json.user_type : '',
    order: exists(_json, 'order') ? _json.order : '1'
  }
}
